import React from 'react';
import { Lightbox } from 'react-modal-image';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

function PreviewCarousel({ sources }) {
  const [modalImageOpen, setModalImageOpen] = React.useState(false);
  const [modalImageSrc, setModalImageSrc] = React.useState(null);

  return (
    <>
      {modalImageOpen && (
        <Lightbox
          medium={modalImageSrc}
          large={modalImageSrc}
          alt=""
          onClose={() => {
            setModalImageOpen(false);
            setModalImageSrc(null);
          }}
        />
      )}
      <Carousel
        renderThumbs={() => null}
        preventMovementUntilSwipeScrollTolerance={true}
        swipeScrollTolerance={50}
      >
        {sources.map((source) => {
          return (
            <button
              key={source}
              className="flex h-full items-center w-full"
              onClick={() => {
                setModalImageOpen(true);
                setModalImageSrc(source);
              }}
            >
              <img
                src={source}
                className="mx-auto max-w-md rounded-md h-96 object-contain"
              />
            </button>
          );
        })}
      </Carousel>
    </>
  );
}

export default PreviewCarousel;
